import {Text, View} from "@react-pdf/renderer";
import React, {useContext} from "react";

import { baseStyles } from "../../styles";
import {PDFContext} from "../../BasePDF";


export const FinanceDealerPaymentInformationPDF = () => {
    const pdfData = useContext(PDFContext)
    if (!pdfData) return null;

    return (
        <View style={{...baseStyles.table}}>
            <View style={{...baseStyles.tableHeader, backgroundColor: pdfData.pageColor}}>
                <Text>Payment Information</Text>
            </View>

            <View>
                <View style={baseStyles.flexBetween}>
                    <Text>Total COD</Text>
                    <Text>{pdfData.cash_due_on_delivery.toDollarFormat()}</Text>
                </View>

                <View style={baseStyles.flexBetween}>
                    <Text>Monthly Payment</Text>
                    <Text>{pdfData.monthly_payment.toDollarFormat()}</Text>
                </View>

                <View style={{...baseStyles.flexBetween}}>
                    <Text>Term:</Text>
                    <Text>{pdfData.term}</Text>
                </View>

                {/*<View style={{...baseStyles.flexBetween}}>*/}
                {/*    <Text>APR</Text>*/}
                {/*    <Text>{pdfData.apr}%</Text>*/}
                {/*</View>*/}

                <View style={{...baseStyles.flexBetween}}>
                    <Text>Days to 1st Payment</Text>
                    <Text>{pdfData.days_to_first_payment}</Text>
                </View>

                {/*<View style={{...baseStyles.flexBetween}}>*/}
                {/*    <Text>Ballon Payment</Text>*/}
                {/*    <Text>{helper.balloon()}</Text>*/}
                {/*</View>*/}
            </View>
        </View>
    )
}